import React from "react";
import "./App.css";

import "@smarthtmlelements/smart-elements/source/modules/smart.splitter.js";

declare global {
  // eslint-disable-next-line
  namespace JSX {
    interface IntrinsicElements {
      "smart-splitter": any;
    }
  }
}

const App: React.FC = () => {
  document.readyState === 'complete' ? init() : window.onload = init;

  function init() {
    const splitter: any = document.querySelector("smart-splitter");

    splitter.dataSource = [
      {
        id: "item0",
        size: "50%",
        content:
          "<smart-splitter>" +
            '<smart-splitter-item size="33%" collapsible id="item1">Item 1</smart-splitter-item>' +
            '<smart-splitter-item size="33%" id="item2">Item 2</smart-splitter-item>' +
            '<smart-splitter-item collapsible id="item3">Item 3</smart-splitter-item>' +
          "</smart-splitter>"
      },
      {
        size: "25%",
        id: "item4",
        content: "Item 4"
      },
      {
        id: "item5",
        content: "Item 5"
      }
    ];
  }
  
  return (
    <div className="App">
      <smart-splitter orientation="horizontal" id="horizontalSplitter"></smart-splitter>
    </div>
  );
}

export default App;
